// extracted by mini-css-extract-plugin
export var bodyRow = "_hr-d";
export var cardColumns = "_hr-e";
export var ellipsesOverflow = "_hr-2";
export var flatBottomCorners = "_hr-3";
export var flatTopCorners = "_hr-4";
export var headerActionsDropdown = "_hr-f";
export var headerBottomRow = "_hr-c";
export var headerTopRow = "_hr-b";
export var orderDetailsWrapper = "_hr-0";
export var orderInfoContainer = "_hr-1";
export var productDetails = "_hr-9";
export var productImage = "_hr-5";
export var responsiveTable = "_hr-8";
export var shipmentContainer = "_hr-a";
export var tableBottomLeft = "_hr-6";
export var tableBottomRight = "_hr-7";
export var trackingLink = "_hr-g";